import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { Image } from "@adora/shared/types/image";

const useAdAssetAdImageResizes = (adAssetGroupId: number, AdImageId?: string, brandId?: string) => {
  const { data, error, isLoading } = useSWR<Image[]>(
    `${RelativeUrl}/ad_asset_groups/${adAssetGroupId}/images/resized?ad_image_id=${AdImageId?.toString()}&brand_id=${brandId}`,
    fetcher
  );

  return {
    images: data || [],
    isLoading,
    error: error ? "Failed to fetch ad images" : null
  };
};

export default useAdAssetAdImageResizes;
